export default __webpack_public_path__ + "static/media/arrow-down-icon.1f196240.svg";